module.exports = __webpack_public_path__ + "media/images/official/special_migration_02-25dc33e47aac1517f07e6eb9cb4ad00e.jpg";